"use client";

import { useContext } from "react";
import { RootStoreContext } from "../context";
import type GlobalStore from "../../mobx/stores/global/store.global";

export function useGlobal(): GlobalStore {
  const root = useContext(RootStoreContext);
  if (!root)
    throw new Error("useGlobal must be used within a RootStoreProvider");
  return root.global;
}
